import { createContext, useCallback, useContext, useState } from 'react';

const LoaderContext = createContext(null);

export function LoaderProvider({ children }) {
  const [active, setActive] = useState(true);

  const showLoader = useCallback(() => setActive(true), []);
  const hideLoader = useCallback(() => setActive(false), []);

  return (
    <LoaderContext.Provider value={{ active, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
}

export function useLoader() {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error('useLoader must be used within a LoaderProvider');
  return ctx;
}
